import './TeamAssignments.css';

export default function TeamAssignments({ team }) {
  return (
    <div className="team-assignments">
      <h4>Assignations de l'équipe</h4>
      <ul>
        {team.map((member) => (
          <li key={member.id}>
            <span>{member.name || member.nom || 'Non assigné'}</span>
            <strong>{Number(member.plans || 0)} plan{Number(member.plans || 0) > 1 ? 's' : ''}</strong>
          </li>
        ))}
      </ul>
    </div>
  );
}
